const DEFAULT_API_BASE_URL = 'https://latthsaab-backend.onrender.com/api';

const stripTrailingSlash = (value) => value.replace(/\/+$/, '');

const normalizeApiBaseUrl = (value) => {
  if (!value) {
    return DEFAULT_API_BASE_URL;
  }

  const normalizedValue = stripTrailingSlash(value);

  try {
    const parsedUrl = new URL(normalizedValue);
    const normalizedPath = parsedUrl.pathname.replace(/\/+$/, '');

    if (!normalizedPath || normalizedPath === '/') {
      parsedUrl.pathname = '/api';
      return stripTrailingSlash(parsedUrl.toString());
    }

    if (normalizedPath === '/api') {
      return stripTrailingSlash(parsedUrl.toString());
    }

    return stripTrailingSlash(`${parsedUrl.origin}/api`);
  } catch {
    return normalizedValue.endsWith('/api') ? normalizedValue : `${normalizedValue}/api`;
  }
};

const envApiUrl = process.env.REACT_APP_API_URL?.trim();

export const API_BASE_URL = normalizeApiBaseUrl(envApiUrl);

export const API_ORIGIN = API_BASE_URL.endsWith('/api')
  ? API_BASE_URL.slice(0, -4)
  : API_BASE_URL;

export const buildApiUrl = (path = '') => {
  if (!path) {
    return API_BASE_URL;
  }

  return `${API_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;
};

const apiConfig = {
  API_BASE_URL,
  API_ORIGIN,
  buildApiUrl
};

export default apiConfig;